import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{attrs:{"color":_vm.color,"outlined":_vm.outlined ? _vm.outlined : false},on:{"click":_vm.collapseButtonHandler}},[_vm._v("\n  "+_vm._s(_vm.collapseButtonLabelValue)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }